// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1966":"d9ff09743b43e5e5","3403":"8f5f88a72d9e01d5","3899":"17c2d8095c70a73a"}[chunkId] + ".js";
};